module.exports = __webpack_public_path__ + "static/img/t7-1.66336bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t7-1.png
// module id = wq2m
// module chunks = 1